import { createAction } from 'redux-act';

export const resetClubScopedState = createAction(
  'reset club-scoped state after team switch'
);
